import React, { useEffect } from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import { useLocation } from 'react-router-dom';

export default function Terms() {
  const location = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
    
    // Shutdown Intercom if it exists
    if (window.Intercom) {
      window.Intercom('shutdown');
    }
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Navbar />
      <main className="flex-1 container mx-auto px-4 py-8">
        <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-sm p-6 sm:p-8">
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-6">
            Terms and Conditions
          </h1>
          
          <div className="prose prose-gray max-w-none">
            <p className="text-sm text-gray-500 mb-8">Last Updated: {new Date().toLocaleDateString()}</p>

            <h2 className="text-xl font-semibold mt-8 mb-4">Cookie Policy</h2>
            <p className="mb-6">
              We use cookies and similar technologies to help personalize content, enhance your experience, and analyze our traffic. By clicking "Accept" on our cookie consent banner, you agree to the storing of cookies on your device for these purposes.
            </p>

            <h3 className="text-lg font-semibold mt-6 mb-3">Types of Cookies We Use</h3>
            <ul className="list-disc pl-6 mb-6 space-y-2">
              <li>
                <strong>Essential Cookies:</strong> These cookies are necessary for the website to function properly and cannot be switched off in our systems.
              </li>
              <li>
                <strong>Authentication Cookies:</strong> Used to remember your login status and maintain your session security.
              </li>
              <li>
                <strong>Preference Cookies:</strong> These cookies enable the website to remember choices you make (such as your preferred settings).
              </li>
            </ul>

            <h3 className="text-lg font-semibold mt-6 mb-3">Managing Cookies</h3>
            <p className="mb-6">
              Most web browsers allow you to control cookies through their settings preferences. However, limiting cookies may impact your experience and functionality of our website.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">1. Definitions</h2>
            <ul className="list-disc pl-6 mb-6 space-y-2">
              <li>"Service": The online platform provided by Pacer Results for uploading, hosting, and displaying Results Data.</li>
              <li>"User": Any individual or entity accessing and using the Service.</li>
              <li>"Results Data": All information, including but not limited to participant names, times, rankings, and any other event-related data, uploaded by Users.</li>
              <li>"Account": A user-specific account created to access and use the Service, if applicable.</li>
            </ul>

            <h2 className="text-xl font-semibold mt-8 mb-4">2. Eligibility and Account Registration</h2>
            <ul className="list-disc pl-6 mb-6 space-y-2">
              <li>Eligibility: You must be at least 18 years of age or have the legal capacity to enter into a binding agreement in your jurisdiction. By using the Service, you represent and warrant that you meet these eligibility requirements.</li>
              <li>Account Registration: In order to access certain features of the Service, you may be required to create an account. You agree to provide accurate, current, and complete information during the registration process and to update such information as necessary.</li>
              <li>Account Security: You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account. Notify us immediately of any unauthorized use or suspected breach of security.</li>
            </ul>

            <h2 className="text-xl font-semibold mt-8 mb-4">3. Service Description</h2>
            <ul className="list-disc pl-6 mb-6 space-y-2">
              <li>Hosting and Display of Results Data: Pacer Results provides an online platform for timing providers and event organisers to upload and host Results Data, which can then be displayed on your website. We do not verify the accuracy or completeness of the Results Data uploaded by Users.</li>
              <li>Service Availability: We strive to maintain the Service's availability but do not guarantee continuous, uninterrupted access. Scheduled maintenance, upgrades, or unforeseen technical issues may result in temporary unavailability.</li>
              <li>Modifications: Pacer Results reserves the right to modify or discontinue, temporarily or permanently, the Service (or any part thereof) with or without notice.</li>
            </ul>

            <h2 className="text-xl font-semibold mt-8 mb-4">4. User Responsibilities and Data Submission</h2>
            <ul className="list-disc pl-6 mb-6 space-y-2">
              <li>Data Ownership: You retain ownership of any Results Data you upload to the Service. By uploading such data, you grant Pacer Results a non-exclusive, worldwide, royalty-free license to use, store, process, and display the data solely for the purpose of operating the Service.</li>
              <li>Accuracy and Legality: You are solely responsible for ensuring that the Results Data you upload is accurate, complete, and does not infringe on any third-party rights. You represent and warrant that you have all necessary rights and permissions to upload and publish the data.</li>
              <li>Data Backup: It is your responsibility to maintain backup copies of your Results Data. Pacer Results is not responsible for any loss or corruption of data.</li>
            </ul>

            <p className="mt-8 text-sm text-gray-500">
              Note: This document is subject to change. Please check back regularly for updates.
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}